import { AWFLayout } from '@ansys-internal/awf-angular/core';

@AWFLayout({})
export class ConceptLayout {
  grid = [['content']] as const;
}
